import SkillApi from '@/api/skill/skill.js'

const state = {
    skills: [],
    skill_category: [],
    skill_category_info: [{0:1,1:2,2:3},{0:2,1:5,2:8}],
    current_category: '',
    temp_category: '',
    star: {},
    not_set_list: [],
    star_infos: {},
    star_info_list: [
        '熟练：该项目工作至少已经做过五次以上，并且连续三次顺利完成',
        '较好：该项目工作至少已经做过三次以上，并且连续二次顺利完成',
        '一般：该项目工作至少已经做过一次以上，并且工作完成情况得到上司的认可',
        '了解：参与到该项目工作中，了解全过程，或者系统地进行了学习，并且模拟完成了任务',
        '不会：从未参与过，也未系统学习研究过',
        '请点击五角星完成您对该技能的自我评估',
    ],
    star_info_list_common: [
        '熟练：证明该项能力的事件描述超过10个，且都是成功的事件',
        '较好：证明该项能力的事件描述超过7个，且都是成功的事件',
        '一般：证明该项能力的事件描述超过5个，且都是成功的事件',
        '了解：证明该项能力的事件描述超过2个，且都是成功的事件',
        '不会：没有证明材料',
        '请点击五角星完成您对该技能的自我评估',
    ],
    domain_str:'',
    star_on_img:'/static/img/star_on_48.png',
    star_off_img:'/static/img/star_off_48.png',
    star_blue_img:'/static/img/star_blue_48.png',
}

const mutations = {
    get_self_score (state, skills) {
        state.skills = skills
    },
    get_categories (state, category) {
        state.skill_category = category
    },
    get_skill_from_category(state, skills){
        state.skills = skills
    },
    set_current_category(state, category){
        state.current_category = category
    },
    skill_category_info(state, category){
        state.skill_category_info = category
    },
    set_domain_str(state, domain){
        state.domain_str = domain
    },
    set_star(state, star){
        var obj = Object.create(state.star)
        var obj_info = Object.create(state.star_infos)
        obj[star[1]] = star[0]
        obj_info[star[1]] = star[2]
        state.star = obj
        state.star_infos = obj_info
        state.current_category.skills.forEach(skill=>{
            if(skill.id === Number(star[1])){
                skill.state = star[3]
            }
        })
    },
    reset_star(state, star){
        state.star = star
    },
    set_not_set_list(state, list){
        state.not_set_list = list['list']
        state.temp_category = list['first_ca']
    },
}
const actions = {
    async get_self_score (context) {
        let res = await SkillApi.get_self_score()
        context.commit('get_self_score', res.data)
    },
    async get_skill_category_info (context) {
        let domain = localStorage.getItem('field')
        let res = await SkillApi.get_skill_category_info({'domain': domain})
        context.commit('skill_category_info', res.data)
    },
    async get_skill_category_info_for_target (context) {
        let domain = localStorage.getItem('field')
        let res = await SkillApi.get_skill_category_info_for_target({'domain': domain})
        context.commit('skill_category_info', res.data)
    },
    async check_user_skill () {
        let domain = localStorage.getItem('field')
        await SkillApi.check_user_skill({'domain': domain})
    },
    async set_domain_id (context, route) {
        if(route){
            localStorage.setItem('field', route)
            context.commit('set_domain_str', route, localStorage.getItem('field'))
        }
    },
    async change_current_category (context, category) {
        context.commit('set_current_category', category)
        let skills = {}
        state.skill_category.forEach(ca=>{
            if(ca.id === state.current_category.id){
                skills = ca.skills
            }
        })
        // let skills = await SkillApi.get_skill_from_category(state.current_category.id)
        context.commit('get_skill_from_category', skills)
    },
    async get_categories (context) {
        let domain = localStorage.getItem('field')
        let info_list = []
        if (domain === 'hr'){
            info_list = context.state.star_info_list
        }else{
            info_list = context.state.star_info_list_common
        }
        let res = await SkillApi.get_category_skill_info({'domain': domain})
        let obj = res.data
        context.commit('get_categories', obj)
        context.commit('set_current_category', obj[0])
        for(var i = 0; i < obj.length; i++ ){
            let temp = obj[i].skills
            // let temp = await SkillApi.get_skill_from_category(obj[i].id)
            for (var x = 0; x< temp.length; x++){
                var star = context.state.star_on_img
                var e_star = context.state.star_off_img
                var star_state = temp[x]
                if(star_state.state){
                    if(star_state.state === 'skilled'){
                        context.commit('set_star', [{0:star, 1:star, 2:star, 3:star, 4:star},star_state.id, info_list[0],'skilled'])
                    }else if(star_state.state === 'well'){
                        context.commit('set_star', [{0:star, 1:star, 2:star, 3:star, 4:e_star}, star_state.id, info_list[1],'well'])
                    }else if(star_state.state === 'ordinary'){
                        context.commit('set_star', [{0:star, 1:star, 2:star, 3:e_star, 4:e_star}, star_state.id, info_list[2],'ordinary'])
                    }else if(star_state.state === 'understood'){
                        context.commit('set_star', [{0:star, 1:star, 2:e_star, 3:e_star, 4:e_star}, star_state.id, info_list[3],'understood'])
                    }else if(star_state.state === 'incompetent'){
                        context.commit('set_star', [{0:star, 1:e_star, 2:e_star, 3:e_star, 4:e_star}, star_state.id, info_list[4],'incompetent'])
                    }
                }else{
                    context.commit('set_star', [{0:e_star, 1:e_star, 2:e_star, 3:e_star, 4:e_star}, star_state.id, context.state.star_info_list[5]])
                }
            }
        }
        let skills = obj[0].skills
        context.commit('get_skill_from_category', skills)
    },
    async check_if_complete(context){
        let temp = []
        let res = state.skill_category
        let first_ca = null
        for (let i = 0; i < res.length; i++){
            if(res[i].skills.length > 0){
                temp.push({
                    'id': res[i].id,
                    'category': res[i].name
                })
                if (first_ca === null){
                    first_ca = res[i]
                }
                for (let x = 0; x < res[i].skills.length; x++){
                    if (res[i].skills[x].state !== 'incompetent'){
                        temp.pop()
                        if (first_ca.id === res[i].id){
                            first_ca = null
                        }
                        break
                    }
                }
            }
        }
        context.commit('set_not_set_list', {'list': temp, 'first_ca': first_ca})
    },
    async click_star (context, event) {
        let domain = localStorage.getItem('field')
        let info_list = []
        if (domain === 'hr'){
            info_list = context.state.star_info_list
        }else{
            info_list = context.state.star_info_list_common
        }
        var skill_id = event.target.getAttribute('data-skill-id')
        var index = event.target.getAttribute('data-index')
        var old_state = event.target.getAttribute('data-state')
        var star = context.state.star_on_img
        var e_star = context.state.star_off_img
        if(index === "4"){
            context.commit('set_star', [{0:star, 1:star, 2:star, 3:star, 4:star}, skill_id, info_list[0],'skilled'])
        }else if(index === "3"){
            context.commit('set_star', [{0:star, 1:star, 2:star, 3:star, 4:e_star}, skill_id, info_list[1],'well'])
        }else if(index === "2"){
            context.commit('set_star', [{0:star, 1:star, 2:star, 3:e_star, 4:e_star}, skill_id, info_list[2],'ordinary'])
        }else if(index === "1"){
            context.commit('set_star', [{0:star, 1:star, 2:e_star, 3:e_star, 4:e_star}, skill_id, info_list[3],'understood'])
        }else if(index === "0"){
            context.commit('set_star', [{0:star, 1:e_star, 2:e_star, 3:e_star, 4:e_star}, skill_id, info_list[4],'incompetent'])
        }
        console.log(state.current_category)
        SkillApi.set_skill_state({skill_id, index,old_state})
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
